import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { Select } from '@/components/Form'

import { ScheduledIntervalType } from './interfaces'
import messages from './messages'
import { getNumericRangeOptions } from './utils'

const StyledSelect = styled(Select)`
  flex-basis: 40%;
`

function Hourly({ readOnly }: ScheduledIntervalType) {
  const intl = useIntl()

  return (
    <StyledSelect
      disabled={readOnly}
      name={`triggerData.hours`}
      className={''}
      label={intl.formatMessage(messages.every)}
      options={getNumericRangeOptions(12)}
      variant={''}
      defaultValue={1}
    />
  )
}

export default Hourly
